import { useState } from "react";
import { normalizeName } from "../../shared/normalizeName";

export function useNameField({
  currentName,
  validate,
  onCommit,
}: {
  currentName: string | undefined;
  validate: (normalizedName: string) => string | null;
  onCommit: (normalizedName: string) => void;
}) {
  const [editValue, setEditValue] = useState<string | null>(null);
  const displayValue = editValue ?? currentName ?? "";

  const normalized = editValue !== null ? normalizeName(editValue) : null;
  const error =
    normalized !== null && normalized.length > 0 && normalized !== currentName
      ? validate(normalized)
      : null;

  const commit = () => {
    if (editValue === null || error) return;
    if (!normalized || normalized === currentName) {
      setEditValue(null);
      return;
    }
    onCommit(normalized);
    setEditValue(null);
  };

  return { value: displayValue, setValue: setEditValue, error, commit };
}
